import { Component, OnInit } from '@angular/core';
import { UserLoginService } from "../../service/user-login.service";
import {AwsUtilService} from "../../service/aws-util.service";

import { GlobalEventsManagerService } from '../../service/global-events-manager.service';
import {CognitoUtilService, LoggedInCallback} from "../../service/cognito-util.service";


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  

  constructor(public userService: UserLoginService, private globalEventsManager: GlobalEventsManagerService,
    public cognito: CognitoUtilService, public awsUtil: AwsUtilService) { }

  ngOnInit() {
    console.log('HomeComponent ngOnInit()');
    console.log("Checking if the user is already authenticated. If so, then redirect to the secure site");
   // this.userService.isAuthenticated(this);
    
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (isLoggedIn) {
      console.log("isLoggedIn");
      this.globalEventsManager.isLoggedIn.emit(true);
      let mythis = this;
      this.cognito.getIdToken({
          callback() {

          },
          callbackWithParam(token: any) {
              // Include the passed-in callback here as well so that it's executed downstream
              console.log("HomeComponent: calling initAwsService in callback", token)
              mythis.awsUtil.initAwsService(null, isLoggedIn, token);
          }
      });
    }

    else{
        this.globalEventsManager.isLoggedIn.emit(false);     
    }
      

  }

 

}



// WEBPACK FOOTER //
// ./src/app/public/home/home.component.ts